import { render, staticRenderFns } from "./FeesNoticeDetailsChargesTable.vue?vue&type=template&id=04f51886"
import script from "./FeesNoticeDetailsChargesTable.vue?vue&type=script&lang=js"
export * from "./FeesNoticeDetailsChargesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports